import { useEffect } from "react";
import { Route, useParams } from "react-router-dom";


import SUATable from "./SUATable";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
};

const SUATab = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;
    const params = useParams<any>();
    useEffect(() => {
    }, [params]);
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                    <Route
                        component={() => (
                        <SUATable {...props} />
                        )}
                    />
            )}
        </div>
    )
}

export default SUATab;
